import { Arch } from 'app/core/domain/ArchTools'

const sortOnArch = (arch: Arch) => (a: number, b: number) => arch === Arch.UPPER ? a - b : b - a

export { sortOnArch }
